<template>
  <TreeItem
    ref="elRef"
    v-slot="{ isExpanded }"
    :value="item.value"
    :level="item.level"
    :parent="item.value.parent_group"
    :class="{ 'opacity-50': isDragging }"
    class="group relative"
    @toggle.prevent
    @click.stop.prevent="$emit('show:detail', item.value.id)"
  >
    <div
      class="md:px-2 md:py-2 py-3 px-4 overflow-hidden border-b border-secondary bg-primary group-hover:bg-primary_hover transition-colors duration-500 flex relative w-full text-primary text-sm"
      :parent="item.value.parent_group"
    >
      <ExpandButton
        v-if="canExpand"
        :isExpanded="isExpanded"
        @click.stop="emit('update:open')"
      />
      <slot name="default" :data="{ item: item }"></slot>
      <DragIndicator :instruction="instruction" />
    </div>
  </TreeItem>
</template>

<script setup>
import { computed, ref, onMounted } from "vue";
import { unrefElement } from "@vueuse/core";
import { TreeItem } from "radix-vue";
import { useDragAndDrop } from "@/Composables/useDragAndDrop";
import { ExpandButton, DragIndicator } from "@/SharedComponents/GroupBuilder";

// Props
const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  canExpand: {
    type: Boolean,
    default: true,
  },
});

// Emits
const emit = defineEmits(["update:open"]);

// Refs
const elRef = ref();

// Computed props
const mode = computed(() =>
  props.item.hasChildren
    ? "expanded"
    : props.item.index + 1 === props.item.parentItem?.children?.length
    ? "last-in-group"
    : "standard"
);

// Drag and drop
const { isDragging, instruction, initialise } = useDragAndDrop({
  item: props.item.value,
  mode: mode.value,
  emit,
});

// Lifecycle hooks
onMounted(() => {
  const element = unrefElement(elRef);
  const dragHandle = element.querySelector(".drag-handle");

  if (element && dragHandle) {
    initialise(element, dragHandle);
  }
});
</script>
